export default __webpack_public_path__ + "static/media/truckdesk_transparent.c317b6e3.png";